export const N_ERROR = 'triggerErrorNote'

export const N_SUCCESS = 'triggerSuccessNote'

export const DATA_REFRESH = 'triggerDataRefresh'

export const UPDATE = 'upsert'

export const DELETE = 'del'

export const LOOKUP = 'lookup'



// WEBPACK FOOTER //
// ./client/store/action-types.js